import type { DemoStatus } from '@app/contracts';
import { create } from 'zustand';

interface DemoState {
  enabled: boolean;
  loaded: boolean;
  status: DemoStatus | null;
  setStatus: (s: DemoStatus | null) => void;
}

export const useDemoStore = create<DemoState>((set) => ({
  enabled: false,
  loaded: false,
  status: null,
  setStatus: (s) => set({ status: s, enabled: Boolean(s?.enabled), loaded: true }),
}));
